import React from 'react';
import PropTypes from 'prop-types';
import { Card, Flex, IconChevronRight } from '@zillow/constellation';

const SectionNav = ({ className, children, isClickable = false }) => {
  return (
    // CDS-2611 have to pass undefined to Card to get it to respect not putting interactive styles
    <Card
      appearance="borderless"
      cardElevation={0}
      cardType="secondary"
      interactive={isClickable ? true : undefined}
      className={className}
    >
      <Flex display="flex" alignItems="center" justifyContent="space-between">
        <div>{children}</div>
        {isClickable && <IconChevronRight fontColor="gray400" size="sm" />}
      </Flex>
    </Card>
  );
};

SectionNav.propTypes = {
  children: PropTypes.node.isRequired,
  isClickable: PropTypes.bool,
};

export default SectionNav;
